import type { RouteRecordRaw } from 'vue-router'
import { UserRole } from '@/types/router'

export const userModelRoutes: RouteRecordRaw[] = [
  {
    path: 'model-upload',
    name: 'ModelUpload',
    component: () => import('@/views/userCenter/UploadModel.vue'),
    meta: {
      title: '模型上传',
      requiresAuth: true,
      roles: [UserRole.USER, UserRole.DESIGNER, UserRole.MANUFACTURER, UserRole.ADMIN],
      icon: 'Upload',
      order: 9,
      breadcrumb: true,
      cache: false,
      description: '3D模型文件上传，支持批量上传和元数据编辑',
    },
  },
  {
    path: 'my-models',
    name: 'MyModels',
    component: () => import('@/views/userCenter/MyModels.vue'),
    meta: {
      title: '我的模型',
      requiresAuth: true,
      roles: [UserRole.USER, UserRole.DESIGNER, UserRole.MANUFACTURER, UserRole.ADMIN],
      icon: 'Box',
      order: 8,
      breadcrumb: true,
      cache: false,
      description: '个人模型库管理，包含已上传、审核中、已发布的模型',
    },
  },
  {
    path: 'model-collection',
    name: 'ModelCollection',
    component: () => import('@/views/userCenter/CollectedDownloadModels.vue'),
    meta: {
      title: '模型收藏',
      requiresAuth: true,
      roles: [UserRole.USER, UserRole.DESIGNER, UserRole.MANUFACTURER, UserRole.ADMIN],
      icon: 'Star',
      order: 9,
      breadcrumb: true,
      cache: false,
      description: '收藏的模型管理，支持分类整理和快速访问',
    },
  },
  {
    path: 'model-edit/:id',
    name: 'EditModel',
    component: () => import('@/views/userCenter/EditModel.vue'),
    meta: {
      title: '编辑模型',
      requiresAuth: true,
      roles: [UserRole.USER, UserRole.DESIGNER, UserRole.MANUFACTURER, UserRole.ADMIN],
      icon: 'Edit',
      order: 10,
      breadcrumb: true,
      breadcrumbParent: 'MyModels',
      cache: false,
      description: '编辑模型信息，修改后重新提交审核',
    },
  },
]
